import classNames from "../../utils/classNames";


export default function VehicleAssemblyProgress({ progressColumns }: { progressColumns: any[] }) {


  return (
    <div className="">
      <div className="mb-3 flex items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">Assembly Progress</p>
        {/* {assemblies.isLoading && <span className="text-xs text-gray-500">Loading...</span>} */}
      </div>

      {progressColumns.length > 0 ? (
        <div className="flex flex-wrap items-start gap-x-6 gap-y-3">
          {progressColumns.map((assembly) => {
            const isCompleted = assembly.totalCount > 0 && assembly.completedCount === assembly.totalCount;

            return (
              <div
                key={assembly.id}
                className={classNames(
                  "rounded-md border px-3 py-2 min-w-40",
                  isCompleted ? "border-green-300 bg-green-50" : "border-gray-200 bg-gray-50"
                )}
              >
                <div className="flex flex-col gap-2">
                  <p className="text-sm font-medium text-gray-800">{assembly.name}</p>
                  {isCompleted ? (
                    <p className="rounded-full text-center bg-green-200 py-0.5  text-xs font-semibold text-green-800">
                      Completed
                    </p>
                  ) : (
                    <p className="text-sm font-semibold text-primary-700">
                      {assembly.completedCount}/{assembly.totalCount}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No assembly progress available.</p>
      )}
    </div>
  )
}